import { render, staticRenderFns } from "./AdiAccessiListComponent.vue?vue&type=template&id=831e5bc6"
import script from "./AdiAccessiListComponent.vue?vue&type=script&lang=js"
export * from "./AdiAccessiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports